<template>
  <div ref="NoRealQueryPage">
    <BasicLayout :left="left" :middle="middle" :right="right" ref="target">

      <!-- 非实时数据查询管理页面 -->
      <template v-slot:left_view>
        <NoRealQueryManagementPage ref='NoRealQueryManagementPage' @textObjChange="textObjChange" @transferMeasureObjForSearch="transferMeasureObjForSearch"></NoRealQueryManagementPage>
      </template>

      <!-- 非实时数据查询数据页面 -->
      <template v-slot:right_view>
        <NoRealQueryListPage ref='NoRealQueryListPage' @pageClick="pageClick" :meterPeriod='meterPeriod' :dataOfNoQueryList='dataOfNoQueryList' :measureObjSelectedAttrs='measureObjSelectedAttrs' :checkedNodesOfMeasureTree='checkedNodesOfMeasureTree'></NoRealQueryListPage>
      </template>
    </BasicLayout>

    <!-- 非实时数据查询搜索第一步弹出框 -->
    <CustomDialog ref='NoRealQuerySearchDialog1' :element='NoRealQuerySearchDialog1.element' :styles='NoRealQuerySearchDialog1.style'>
      <template v-slot:dialog-content>
        <NoRealQuerySearchDialog1 ref="NoRealQuerySearch1" :nodeData="nodeData" :checkedNodesOfNeTree="checkedNodesOfNeTree" :checkedNodesOfMeasureTree="checkedNodesOfMeasureTree"></NoRealQuerySearchDialog1>
      </template>
    </CustomDialog>

    <!-- 非实时数据查询搜索第二步弹出框 -->
    <CustomDialog ref='NoRealQuerySearchDialog2' :element='NoRealQuerySearchDialog2.element' :styles='NoRealQuerySearchDialog2.style'>
      <template v-slot:dialog-content>
        <NoRealQuerySearchDialog2 ref="NoRealQuerySearch2" :timeCycles="timeCycles" :kewWordsOfSort="kewWordsOfSort"></NoRealQuerySearchDialog2>
      </template>
    </CustomDialog>

    <!-- 非实时数据查询快捷导出弹出框 -->
    <CustomDialog ref='QuickExportDialog' :element='QuickExportDialog.element' :styles='QuickExportDialog.style'>
      <template v-slot:dialog-content>
        <QuickExportDialog ref="QuickExport" :timeCycles="timeCycles"></QuickExportDialog>
      </template>
    </CustomDialog>

    <!-- 非实时数据查询批量导出弹出框 -->
    <CustomDialog ref='BatchExportDialog' :element='BatchExportDialog.element' :styles='BatchExportDialog.style'>
      <template v-slot:dialog-content>
        <BatchExportDialog ref="BatchExport" :timeCycles="timeCycles"></BatchExportDialog>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import NoRealQueryManagementPage from '../../components/pmConfig/NoRealQuery/NoRealQueryManagementPage';
import NoRealQueryListPage from '../../components/pmConfig/NoRealQuery/NoRealQueryListPage';
import CustomDialog from '../../components/common/CustomDialog';
import NoRealQuerySearchDialog1 from '../../components/pmConfig/NoRealQuery/dialog/NoRealQuerySearchDialog1';
import NoRealQuerySearchDialog2 from '../../components/pmConfig/NoRealQuery/dialog/NoRealQuerySearchDialog2';
import QuickExportDialog from '../../components/pmConfig/NoRealQuery/dialog/QuickExportDialog';
import BatchExportDialog from '../../components/pmConfig/NoRealQuery/dialog/BatchExportDialog';
import DateUtil from '../../components/pmConfig/Util/DateUtil';
import commonUtil from '../../components/pmConfig/RealTimeTask/commonUtil';
import { EventBus } from '../../plugins/eventBus';
import Router from "../../router";

export default {
  name: 'NoRealQueryPage',
  components: {
    BasicLayout,
    NoRealQueryManagementPage,
    NoRealQueryListPage,
    CustomDialog,
    NoRealQuerySearchDialog1,
    NoRealQuerySearchDialog2,
    QuickExportDialog,
    BatchExportDialog
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('Pm.noRealDataQuery')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.cycleMeasurement')}/${this.$t('Pm.noRealDataQuery')}`
      },
      meterPeriod: 2,
      NoRealQuerySearchDialog1: {
        style: {
          width: '40%',
          height: '60%',
          visible: false,
          model: true
        },
        element: {
          title: `${this.$t('Pm.queryInfo')}:${this.$t('Pm.first')}`,
          target: this.$refs.NoRealQueryPage,
          refName: 'NoRealQuerySearchDialog1Element',
          buttonGroup: [
            { click: this.closeNoRealQuerySearchDialog1, buttonModel: { content: this.$t('Pm.cancel') } },
            { click: this.nextForSearch, buttonModel: { content: this.$t('Pm.nextStep') } }
          ],
          isClose: true
        }
      },
      NoRealQuerySearchDialog2: {
        style: {
          width: '40%',
          height: '60%',
          visible: false,
          model: true
        },
        element: {
          title: `${this.$t('Pm.queryInfo')}:${this.$t('Pm.second')}`,
          target: this.$refs.NoRealQueryPage,
          refName: 'NoRealQuerySearchDialog2Element',
          buttonGroup: [
            { click: this.closeNoRealQuerySearchDialog2, buttonModel: { content: this.$t('Pm.cancel') } },
            { click: this.preForSearch, buttonModel: { content: this.$t('Pm.preStep') } },
            { click: this.dataSearchConfigComplete, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
          ],
          isClose: true
        }
      },

      QuickExportDialog: {
        style: {
          width: '50%',
          height: '71%',
          visible: false,
          model: true
        },
        element: {
          title: this.$t('Pm.quickExport'),
          target: this.$refs.NoRealQueryPage,
          refName: 'QuickExportDialogElement',
          buttonGroup: [
            { click: this.closeQuickExportDialog, buttonModel: { content: this.$t('Pm.cancel') } },
            { click: this.QuickExport, buttonModel: { content: this.$t('Pm.confirm'), isPrimary: true } }
          ],
          isClose: true
        }
      },

      BatchExportDialog: {
        style: {
          width: '50%',
          height: '71%',
          visible: false,
          model: true
        },
        element: {
          title: this.$t('Pm.batchExport'),
          target: this.$refs.NoRealQueryPage,
          refName: 'BatchExportDialogElement',
          buttonGroup: [
            { click: this.closeBatchExportDialog, buttonModel: { content: this.$t('Pm.cancel') } },
            { click: this.BatchExport, buttonModel: { content: this.$t('Pm.confirm'), isPrimary: true } }
          ],
          isClose: true
        }
      },
      nodeData: {},
      searchConditions: {
        commonAttributes: [],
        exportFileName: '',
        counterTypeId: '',
        meterPeriod: '',
        orderConditions: [],
        neids: [], // 网元树点击信息
        kpiCodes: [], // 测量对象树点击信息
        queryType: '',
        beginDateTime: '',
        finishDateTime: ''
      },
      kewWordsOfSort: [],
      counterTypeId: '',
      measureObjectTypeCode: '',
      neVersionId: '',
      neTypeId: '',
      textObj: {
        nodeText: '',
        parentText: '',
        rootText: ''
      },
      allTimePerions: [
        {
          key: 1,
          value: this.$t('Pm.fiveMinutes')
        },
        {
          key: 2,
          value: this.$t('Pm.fifteenMinutes')
        },
        {
          key: 4,
          value: this.$t('Pm.thirtyMinutes')
        },
        {
          key: 8,
          value: this.$t('Pm.oneHour')
        },
        {
          key: 16,
          value: this.$t('Pm.oneDay')
        },
      ],
      checkedNodesOfNeTree: [], // 存放网元neIds树选择节点信息
      checkedNodesOfMeasureTree: [], // 存放测量对象树选择节点信息
      dataOfNoQueryList: [{}], // 存放查询数据表的动态数据
      measureObjSelectedAttrs: [], // 存放测量对象数的选择节点信息（处理后）
      timeCycles: [], // 存放测量周期下拉菜单列表信息
      neIds: [], // 存放当前所有有效网元信息
      indicators: [], // 存放选中节点的相关counter信息
      currentPage: 1,
      searchCacheOfHistory: {},
      searchCacheOfLast: {},
      lastOrHistory: 3
    };
  },
  methods: {

    // 打开数据查询第一步对话框
    showNoRealQuerySearchDialog1() {
      // 默认展开测量对象树和网元树的所有节点并全部选中
      this.$refs.NoRealQuerySearch1.$refs.NeTreeForDataSearch.getNeTreeForDataSearch(this.neTypeId, this.measureObjectTypeCode);
      this.$refs.NoRealQuerySearch1.$refs.MeasureTreeForDataSearch.getMeasureTreeForDataSearch(this.neTypeId, this.counterTypeId);
      this.$refs.NoRealQuerySearchDialog1.show();
    },

    // 数据查询下一步
    nextForSearch() {
      // 获取选择的网元树和测量对象树节点信息
      const checkedNodesOfNe = this.$refs.NoRealQuerySearch1.$refs.NeTreeForDataSearch.checkedNodesOfNeTreeForDataSearch;
      const checkedNodesOfMeasure = this.$refs.NoRealQuerySearch1.$refs.MeasureTreeForDataSearch.checkedNodesOfMeasureTreeForDataSearch;

      this.$refs.NoRealQuerySearch2.bindValidateOfQueryDialog();

      // 选择数据量判断
      if (checkedNodesOfNe.length == 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectResource') });
        return;
      }
      if (checkedNodesOfMeasure.length == 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMOplease') });
        return;
      }

      // 将选择的节点信息存入父组件变量中
      this.searchConditions.neids = [];
      for (let i = 0; i < checkedNodesOfNe.length; i++) {
        const selectNodeOfNeTree = checkedNodesOfNe[i];
        // 只筛选出叶节点信息
        if (selectNodeOfNeTree.isLeaf) {
          this.searchConditions.neids.push(selectNodeOfNeTree.attributes.neId);
        }
      }
      this.searchConditions.kpiCodes = [];
      this.measureObjSelectedAttrs = [];
      for (let j = 0; j < checkedNodesOfMeasure.length; j++) {
        const selectNodeOfMeasureTree = checkedNodesOfMeasure[j];
        // 只筛选出叶节点信息
        if (selectNodeOfMeasureTree.isLeaf) {
          this.measureObjSelectedAttrs.push({
            kpiCode: selectNodeOfMeasureTree.attributes.counterCode,
            kpiNameCn: selectNodeOfMeasureTree.attributes.counterCodeCn,
            kpiNameEn: selectNodeOfMeasureTree.attributes.counterCodeEn,
            kpiUnitCn: selectNodeOfMeasureTree.attributes.counterUnitCn,
            kpiUnitEn: selectNodeOfMeasureTree.attributes.counterUnitEn
          });
          this.searchConditions.kpiCodes.push(selectNodeOfMeasureTree.attributes.counterCode);
        }
      }
      this.$refs.NoRealQuerySearchDialog1.close();
      this.$refs.NoRealQuerySearchDialog2.show();

      // 点击下一步之前将树的选择节点信息，放入父组件缓存中，点击上一步时回填选择状态
      this.checkedNodesOfNeTree = this.$refs.NoRealQuerySearch1.$refs.NeTreeForDataSearch.checkedNodesOfNeTreeForDataSearch;
      this.checkedNodesOfMeasureTree = this.$refs.NoRealQuerySearch1.$refs.MeasureTreeForDataSearch.checkedNodesOfMeasureTreeForDataSearch;

      // 加载测量周期下拉菜单列表初始化信息
      this.loadTimeCycle(this.nodeData.attributes.meterTimePeriod);
    },

    // 数据查询上一步
    preForSearch() {
      this.$refs.NoRealQuerySearch1.$refs.NeTreeForDataSearch.getNeTreeForDataSearch(this.neTypeId, this.measureObjectTypeCode);
      this.$refs.NoRealQuerySearch1.$refs.MeasureTreeForDataSearch.getMeasureTreeForDataSearch(this.neTypeId, this.counterTypeId);
      this.$refs.NoRealQuerySearchDialog2.close();
      // 回填上一步的网元树和测量对象树选择状态并全部展开；
      this.$refs.NoRealQuerySearch1.$refs.NeTreeForDataSearch.checkedNodesOfNeTreeForDataSearch = this.checkedNodesOfNeTree;
      this.$refs.NoRealQuerySearch1.$refs.NeTreeForDataSearch.$refs.neTreeForDataSearch.expandAll();
      this.$refs.NoRealQuerySearch1.$refs.MeasureTreeForDataSearch.checkedNodesOfMeasureTreeForDataSearch = this.checkedNodesOfMeasureTree;
      this.$refs.NoRealQuerySearch1.$refs.MeasureTreeForDataSearch.$refs.measureTreeForDataSearch.expandAll();
      this.$refs.NoRealQuerySearchDialog1.show();
    },

    // 数据查询完成
    dataSearchConfigComplete() {
      // 执行表单校验
      const ruleDatas = this.$refs.NoRealQuerySearch2.validateOfQueryDialog();
      if (!ruleDatas) {
        return;
      }

      // 0：普通查询 1：最新查询
      const lastOrHistory = this.$refs.NoRealQuerySearch2.timePeriodCycle;
      this.lastOrHistory = lastOrHistory;

      // 封装查询请求参数
      const params = {
        commonAttributes: this.searchConditions.commonAttributes,
        exportFileName: this.searchConditions.exportFileName,
        counterTypeId: this.nodeData.attributes.counterTypeId,
        meterPeriod: this.$refs.NoRealQuerySearch2.meterTimePeriod,
        kpiCodes: this.searchConditions.kpiCodes,
        orderConditions: [],
        neids: this.searchConditions.neids,
        queryType: 1,
        queryTypeOfLastQuery: this.$refs.NoRealQuerySearch2.queryType,
        beginDateTime: this.$refs.NoRealQuerySearch2.meterBegTime,
        finishDateTime: this.$refs.NoRealQuerySearch2.meterEndTime,
        page: {
          pageNo: 1,
          pageSize: 25
        },
        systemId: 1
      };
      this.meterPeriod = params.meterPeriod;
      if (lastOrHistory == '0') {

        this.searchCacheOfHistory = {
          beginDateTime: DateUtil.getDateString(params.beginDateTime),
          counterTypeId: params.counterTypeId,
          finishDateTime: DateUtil.getDateString(params.finishDateTime),
          kpiCodes: params.kpiCodes,
          meterPeriod: params.meterPeriod,
          neids: params.neids,
          orderConditions: params.orderConditions,
          page: params.page,
          systemId: params.systemId,
        }
        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/pm/query/historyQueryData1.html', {
          beginDateTime: DateUtil.getDateString(params.beginDateTime),
          counterTypeId: params.counterTypeId,
          finishDateTime: DateUtil.getDateString(params.finishDateTime),
          kpiCodes: params.kpiCodes,
          meterPeriod: params.meterPeriod,
          neids: params.neids,
          orderConditions: params.orderConditions,
          page: params.page,
          systemId: params.systemId,
        }).then((response) => {
          // 根据返回结果动态填充查询列表数据
          const resultOfGrid = response.data.resultVal.result;
          if (resultOfGrid.length != 0) {
            this.dataOfNoQueryList = resultOfGrid;
            this.$refs.NoRealQueryListPage.page.totalRecordsCount = response.data.resultVal.totalCount;
            this.$refs.NoRealQueryListPage.page.currentPage = 1;
          } else {
            this.dataOfNoQueryList = [];
            this.$refs.NoRealQueryListPage.page.totalRecordsCount = 0;
            this.$refs.NoRealQueryListPage.page.currentPage = 1;
          }
          this.$loading.hideLoadding();
        });
      } else if (lastOrHistory == '1') {

        this.searchCacheOfLast = {
          counterTypeId: params.counterTypeId,
          kpiCodes: params.kpiCodes,
          meterPeriod: params.meterPeriod,
          neids: params.neids,
          orderConditions: params.orderConditions,
          page: params.page,
          queryType: parseInt(params.queryTypeOfLastQuery),
          systemId: params.systemId,
        }
        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/pm/query/lastQueryData.html', {
          counterTypeId: params.counterTypeId,
          kpiCodes: params.kpiCodes,
          meterPeriod: params.meterPeriod,
          neids: params.neids,
          orderConditions: params.orderConditions,
          page: params.page,
          queryType: parseInt(params.queryTypeOfLastQuery),
          systemId: params.systemId,
        }).then((response) => {
          // 根据返回结果动态填充查询列表数据
          const resultOfGrid = response.data.resultVal.result;
          this.dataOfNoQueryList = [];
          this.dataOfNoQueryList = resultOfGrid;
          this.$refs.NoRealQueryListPage.page.totalRecordsCount = response.data.resultVal.totalCount;
          this.$refs.NoRealQueryListPage.page.currentPage = 1;
          this.$loading.hideLoadding();
        });
      }
      this.$refs.NoRealQuerySearchDialog2.close();
    },

    // 数据查询第一步对话框关闭
    closeNoRealQuerySearchDialog1() {
      this.$refs.NoRealQuerySearchDialog1.close();
    },

    // 数据查询第二步对话框关闭
    closeNoRealQuerySearchDialog2() {
      this.$refs.NoRealQuerySearchDialog2.close();
    },

    // 打开快捷导出对话框
    showQuickExportDialog() {
      this.loadTimeCycle(10);
      this.$refs.QuickExport.setTodayBeginTime();
      this.$refs.QuickExport.setTodayEndTime();
      this.$refs.QuickExport.startTimeEnabled = false;
      this.$refs.QuickExport.endTimeEnabled = false;
      this.$refs.QuickExport.bindValidateOfQuickDialog();
      this.$refs.QuickExportDialog.show();
    },

    // 快捷导出完成
    QuickExport() {
      // 执行表单校验
      const ruleDatas = this.$refs.QuickExport.validateOfQuickExportDialog();
      if (!ruleDatas) {
        return;
      }

      // 加载导出名称
      this.loadExportFileName();

      let filterIndicator = this.indicators;
      let timeCycle = this.$refs.QuickExport.paramsOfQuickExport.meterTimePeriod;
      if(timeCycle != 2){
        filterIndicator = this.indicators.filter(item => item.indexOf('U') < 0)
      }

      let params = {
        startTime: DateUtil.getDateString(this.$refs.QuickExport.paramsOfQuickExport.meterBegTime),
        endTime: DateUtil.getDateString(this.$refs.QuickExport.paramsOfQuickExport.meterEndTime),
        cycle: timeCycle,
        counterTypeID: this.nodeData.attributes.counterTypeId,
        fileName: this.searchConditions.exportFileName,
        neIdList: this.neIds.toString(),
        indicatorList: filterIndicator
      }
      // 导出之前增加虚拟ajax请求，防止session超时拦截不到该请求
      this.$axios.get('/lte/pm/query/testAjax').then((response) => {
        const result = response.data;
        if (result.errorCode == "SUCCESS"){
          window.open(`${window.location.protocol}//${window.location.host}//lte/pm/query/exportQuickQueryData.html${commonUtil.analyticParameter({
            systemId: 1,
            beginDateTime: params.startTime,
            finishDateTime: params.endTime,
            meterPeriod: params.cycle,
            counterTypeId: params.counterTypeID,
            exportFileName: params.fileName,
            neids: params.neIdList,
            kpiCodes: params.indicatorList
          })}`)
        } else {
          // 路由跳转到登录界面
          sessionStorage.removeItem('principal');
          localStorage.removeItem('mldn-session-id')
          Router.push({
            path: '/login'
          });
          Router.go(1);
        }
      });
      this.$refs.QuickExportDialog.close();
    },

    // 关闭快捷导出对话框
    closeQuickExportDialog() {
      this.$refs.QuickExportDialog.close();
    },

    // 打开批量导出对话框
    showBatchExportDialog() {
      this.$refs.BatchExport.getNeTreeOfBatchExport(this.nodeData.attributes.neTypeId, this.nodeData.attributes.measureObjectTypeCode ? this.nodeData.attributes.measureObjectTypeCode : '');
      this.loadTimeCycle(10);
      this.$refs.BatchExport.$refs.neTreeForBatchExport.expandAll();

      this.$refs.BatchExport.setTodayBeginTime();
      this.$refs.BatchExport.setTodayEndTime();
      this.$refs.BatchExport.startTimeEnabledOfBatch = false;
      this.$refs.BatchExport.endTimeEnabledOfBatch = false;

      this.$refs.BatchExport.bindValidateOfBatchDialog();
      this.$refs.BatchExportDialog.show();
    },

    // 批量导出完成
    BatchExport() {
      // 执行表单校验
      const ruleDatas = this.$refs.BatchExport.validateOfBatchExportDialog();
      if (!ruleDatas) {
        return;
      }

      // 获取选择的网元树节点信息
      const checkedNodesOfBatchExport = this.$refs.BatchExport.checkedNodesOfBatchExport;

      // 选择数据量判断
      if (checkedNodesOfBatchExport.length == 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectResource') });
        return;
      }

      const neids = []; // 存放选择的网元id列表
      for (let i = 0; i < checkedNodesOfBatchExport.length; i++) {
        if (checkedNodesOfBatchExport[i].isLeaf) {
          neids.push(checkedNodesOfBatchExport[i].attributes.neId);
        }
      }

      let params = {
        startTime: DateUtil.getDateString(this.$refs.BatchExport.paramsOfBatchExport.meterBegTime),
        endTime: DateUtil.getDateString(this.$refs.BatchExport.paramsOfBatchExport.meterEndTime),
        cycle: this.$refs.BatchExport.paramsOfBatchExport.meterTimePeriod,
        neTypeID: this.nodeData.attributes.neTypeId || '',
        measureType: this.nodeData.attributes.measureObjectTypeCode || '',
        neIdList: neids.toString()
      }

      // 导出之前增加虚拟ajax请求，防止session超时拦截不到该请求
      this.$axios.get('/lte/pm/query/testAjax').then((response) => {
        const result = response.data;
        if (result.errorCode == "SUCCESS") {
          window.open(`${window.location.protocol}//${window.location.host}//lte/pm/query/exportByInterval.html${commonUtil.analyticParameter({
            commonAttributes: '',
            orderConditions: [].toString(),
            neIds: params.neIdList,
            measureTypCode: params.measureType,
            neTypeId: params.neTypeID,
            meterperiod: params.cycle,
            beginDateTime: params.startTime,
            finishDateTime: params.endTime,
            systemId: 1,
          })}`)
        } else {
          // 路由跳转到登录界面
          sessionStorage.removeItem('principal');
          localStorage.removeItem('mldn-session-id')
          Router.push({
            path: '/login'
          });
          Router.go(1);
        }
      });
      this.$refs.BatchExportDialog.close();
    },

    // 关闭批量导出对话框
    closeBatchExportDialog() {
      this.$refs.BatchExportDialog.close();
    },

    // 加载公共属性和排序字段信息
    loadCommonAttrAndSortKeyWords() {
      this.$axios.get('/lte/pm/query/getCommonAttributes.html', {
        counterTypeId: this.counterTypeId,
        neTypeId: this.neVersionId,
        neVersionId: this.neTypeId,
        systemId: '1'
      }).then((response) => {
        const result = response.data.resultVal;
        for (let i = 0; i < result.length; i++) {
          this.searchConditions.commonAttributes.push(result[i]);
          this.kewWordsOfSort.push(
            {
              sortKey: result[i],
              sortKeyName: this.$t(`Pm.${result[i]}`)
            }
          );
        }
      });
    },

    // 加载导出文件名
    loadExportFileName() {
      this.searchConditions.exportFileName = `${this.textObj.rootText}_${this.textObj.parentText}_${this.textObj.nodeText}`;
    },

    // 加载测量周期下拉菜单列表初始化信息
    loadTimeCycle(timeCycle) {
      this.timeCycles = [];
      for (let i = 0; i < this.allTimePerions.length; i++) {
        if (this.allTimePerions[i].key & timeCycle) {
          this.timeCycles.push(
            {
              value: this.allTimePerions[i].key,
              text: this.allTimePerions[i].value
            }
          );
        }
      }
    },

    // 加载所有有效网元信息
    loadAllAvailableNeByNeTypeId() {
      this.neIds = [];
      this.$axios.get('/lte/pm/pmne/getAllAvailableNeByNeTypeId.html', {
        systemId: 1,
        neTypeId: this.nodeData.attributes.neTypeId
      }).then((response) => {
        const result = response.data.resultVal;
        for (let i = 0; i < result.length; i++) {
          this.neIds.push(result[i].neId);
        }
      });
    },

    // 加载网元树选择测量对象相关指标信息
    loadIndicator() {
      this.indicators = [];
      this.$axios.post('/lte/pm/indicator/getIndicator.html', {
        counterTypeId: this.counterTypeId,
        neTypeId: this.nodeData.attributes.neTypeId,
        neVersionId: this.nodeData.attributes.neVersionId,
        systemId: 1,
        timeCycle: 1,
      }).then((response) => {
        const result = response.data.resultVal;
        for (let i = 0; i < result.length; i++) {
          this.indicators.push(result[i].counterCode);
        }
      });
    },

    // 点击测量对象树节点信息获取，内容为节点信息
    transferMeasureObjForSearch(node) {
      this.nodeData = node;
      if (node.attributes.counterTypeId != '' && node.attributes.counterTypeId != undefined) {
        this.neVersionId = this.nodeData.attributes.neVersionId;
        this.counterTypeId = this.nodeData.attributes.counterTypeId;
        this.measureObjectTypeCode = this.nodeData.attributes.measureObjectTypeCode;
        this.neTypeId = this.nodeData.attributes.neTypeId;
        this.loadCommonAttrAndSortKeyWords();
        this.loadExportFileName();
        this.loadIndicator();
        this.loadAllAvailableNeByNeTypeId(); // 加载所有有效网元信息
      }
    },

    pageClick(currentPage) {

      if(this.lastOrHistory == '0'){
        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/pm/query/historyQueryData1.html', {
          beginDateTime: this.searchCacheOfHistory.beginDateTime,
          counterTypeId: this.searchCacheOfHistory.counterTypeId,
          finishDateTime: this.searchCacheOfHistory.finishDateTime,
          kpiCodes: this.searchCacheOfHistory.kpiCodes,
          meterPeriod: this.searchCacheOfHistory.meterPeriod,
          neids: this.searchCacheOfHistory.neids,
          orderConditions: this.searchCacheOfHistory.orderConditions,
          page: {
            pageNo: currentPage,
            pageSize: 25
          },
          systemId: this.searchCacheOfHistory.systemId,
        }).then((response) => {
          // 根据返回结果动态填充查询列表数据
          const resultOfGrid = response.data.resultVal.result;
          this.dataOfNoQueryList = resultOfGrid;
          this.$refs.NoRealQueryListPage.page.totalRecordsCount = response.data.resultVal.totalCount;
          this.$refs.NoRealQueryListPage.page.currentPage = response.data.resultVal.pageNo;
          this.$loading.hideLoadding();
        });
      } else if (this.lastOrHistory == '1'){
        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/pm/query/lastQueryData.html', {
          counterTypeId: this.searchCacheOfLast.counterTypeId,
          kpiCodes: this.searchCacheOfLast.kpiCodes,
          meterPeriod: this.searchCacheOfLast.meterPeriod,
          neids: this.searchCacheOfLast.neids,
          orderConditions: this.searchCacheOfLast.orderConditions,
          page: {
            pageNo: currentPage,
            pageSize: 25
          },
          queryType: this.searchCacheOfLast.queryType,
          systemId: this.searchCacheOfLast.systemId,
        }).then((response) => {
          // 根据返回结果动态填充查询列表数据
          const resultOfGrid = response.data.resultVal.result;
          this.dataOfNoQueryList = resultOfGrid;
          this.$refs.NoRealQueryListPage.page.totalRecordsCount = response.data.resultVal.totalCount;
          this.$refs.NoRealQueryListPage.page.currentPage = response.data.resultVal.pageNo;
          this.$loading.hideLoadding();
        });
      }

    },

    // 点击测量对象树节点信息获取，内容为父节点和根节点信息
    textObjChange(textObj) {
      this.textObj = textObj;
    },

    // 点击测量对象树节点信息获取，内容为父节点和根节点信息
    treeNodeForQuery(node) {
      this.nodeData = node;
    },
  }
};
</script>

<style>

</style>
